/*
 * tk-grid-promo.js — vkládá kampaňové bannery mezi produktové karty v mřížce kolekce.
 *
 * Kontext: mřížku na kolekcích rendruje Globo client-side (#gf-products), server posílá
 * jen prázdná <li> (blok _product-card je v templates/collection.json disabled). Banner
 * proto nejde vyrenderovat do mřížky Liquidem — vkládáme ho až po Globo renderu, stejně
 * jako to dělá tk-pin-product.js s přeskládáním pořadí.
 *
 * Markup přichází ze serveru v <template id="tk-grid-promo-tpl-tile|-wide">
 * (sections/main-collection.liquid) → obrázek, odkaz i tlačítko jdou přes normální
 * Liquid a jsou locale-aware. JS tady řeší JEN umístění.
 *
 * DVA NEZÁVISLÉ TYPY, můžou běžet zároveň:
 *   tile — dlaždice velikosti produktové karty. Pozice dle `mode` (seed/random/fixed),
 *          další po každých `repeatEvery` produktech.
 *   wide — pruh přes CELOU šířku mřížky, po `rowsBetween` řadách produktů. Počet sloupců
 *          se měří za běhu (láme se podle breakpointu) a při resize se pruhy přeskládají.
 *
 * Pozice se počítají v indexech PRODUKTOVÝCH karet (bannery se do nich nezapočítávají),
 * takže rozestupy drží bez ohledu na to, kolik bannerů už v mřížce je. Při donačítání
 * (infinite scroll) přibývají další.
 */
(function () {
  'use strict';

  var cfg = window.__tkGridPromo;
  if (!cfg) return;

  var MAX_PROMOS = 12; // pojistka proti nesmyslné konfiguraci (repeat = 1 apod.)
  // Nejdřívější pozice dlaždice a minimální odstup od pruhu jsou nastavitelné —
  // dva bannery blízko sebe působí jako spam a v první řadě chce mít zákazník produkty.
  var MIN_INDEX = Math.max(1, parseInt((cfg.tile || {}).minIndex, 10) || 8);
  var MIN_ROWS_APART = Math.max(1, parseInt(cfg.gapRows, 10) || 3);

  // Náhoda se losuje JEDNOU za načtení stránky. Kdyby se losovalo v každém průchodu,
  // dlaždice by poskakovala při každém filtrování i donačtení.
  var pageRandom = Math.random();
  var lastCols = 0;

  var TYPES = [
    { key: 'tile', opt: cfg.tile || {}, tpl: 'tk-grid-promo-tpl-tile', startIdx: null },
    { key: 'wide', opt: cfg.wide || {}, tpl: 'tk-grid-promo-tpl-wide', startIdx: null },
  ];

  function template(id) {
    var tpl = document.getElementById(id);
    return tpl && tpl.content && tpl.content.firstElementChild ? tpl : null;
  }

  function grid() {
    return document.querySelector('#gf-products') || document.querySelector('ul.product-grid');
  }

  /* Reálné karty = <li> které Globo naplnil. Server-rendered prázdná <li data-product-id>
     (disabled _product-card blok) mají atribut taky, ale žádný obsah → musíme filtrovat,
     jinak bychom banner vložili do skeletonu a Globo by ho vzápětí zahodil. */
  function cards(g) {
    var lis = g.querySelectorAll(':scope > li:not(.hidden-box):not(.gf-empty)');
    var out = [];
    for (var i = 0; i < lis.length; i++) {
      if (lis[i].hasAttribute('data-tk-grid-promo')) continue;
      if (lis[i].querySelector('product-card, .product-card')) out.push(lis[i]);
    }
    return out;
  }

  /* Kolik sloupců má mřížka PRÁVĚ TEĎ. Globo si grid stylují sami (cizí CDN, pravidla
     nepřečteme), proto měříme computed hodnotu; když grid není display:grid, spočítáme
     karty se stejným offsetTop = první řada. */
  function columnCount(g, items) {
    var tracks = getComputedStyle(g).gridTemplateColumns;
    if (tracks && tracks !== 'none') {
      var n = tracks.trim().split(/\s+/).length;
      if (n >= 1 && n <= 12) return n;
    }
    if (items && items.length) {
      var top = items[0].offsetTop;
      var c = 0;
      for (var i = 0; i < items.length; i++) {
        if (Math.abs(items[i].offsetTop - top) > 4) break;
        c++;
      }
      if (c > 0) return c;
    }
    return 4;
  }

  // FNV-1a, ať je pozice deterministická z collection.id (režim 'seed').
  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = (h * 16777619) >>> 0;
    }
    return h >>> 0;
  }

  function firstIndex(opt, count) {
    if (opt.mode === 'fixed') {
      var fixed = (opt.fixedIndex || 5) - 1;
      return Math.max(0, Math.min(fixed, count));
    }
    var maxIdx = Math.min(count, opt.maxIndex || 12);
    if (maxIdx <= MIN_INDEX) return Math.min(MIN_INDEX, count);
    var span = maxIdx - MIN_INDEX;
    var r = opt.mode === 'seed' ? (hash(String(cfg.seed || '0')) % 10007) / 10007 : pageRandom;
    return MIN_INDEX + Math.floor(r * span);
  }

  // Indexy (v poli produktových karet), PŘED které patří banner daného typu.
  function wantedPositions(t, count, cols) {
    var out = [];
    var p;

    if (t.key === 'wide') {
      var rows = parseInt(t.opt.rowsBetween, 10) || 2;
      var step = Math.max(1, cols * rows);
      // `p < count` (ne <=) → pruh se nikdy nepověsí až za poslední kartu.
      for (p = step; p < count && out.length < MAX_PROMOS; p += step) {
        out.push(p);
        if (!t.opt.repeat) break;
      }
      return out;
    }

    var every = parseInt(t.opt.repeatEvery, 10) || 0;
    for (p = t.startIdx; p < count && out.length < MAX_PROMOS; p += every) {
      out.push(p);
      if (every <= 0) break;
    }
    return out;
  }

  /* Dlaždice nesmí sedět hned vedle pruhu — dva bannery u sebe působí jako spam.
     Kolizní pozici odsuneme za pruh o `MIN_ROWS_APART` řad. */
  function keepApart(tilePos, widePos, cols, count) {
    if (!widePos.length) return tilePos;
    var gap = MIN_ROWS_APART * cols;
    var out = [];
    for (var i = 0; i < tilePos.length; i++) {
      var p = tilePos[i];
      var moved = true;
      // Iterativně: odsun od jednoho pruhu může narazit na další.
      while (moved) {
        moved = false;
        for (var j = 0; j < widePos.length; j++) {
          if (Math.abs(p - widePos[j]) < gap) {
            p = widePos[j] + gap;
            moved = true;
          }
        }
      }
      if (p < count && out.indexOf(p) === -1) out.push(p);
    }
    return out;
  }

  function promosOf(g, key) {
    return g.querySelectorAll(':scope > [data-tk-grid-promo="' + key + '"]');
  }

  function unhideAll(g) {
    var hidden = g.querySelectorAll(':scope > [data-tk-promo-hidden]');
    for (var i = 0; i < hidden.length; i++) {
      hidden[i].style.removeProperty('display');
      hidden[i].removeAttribute('data-tk-promo-hidden');
    }
  }

  function removeAll(g, key) {
    var promos = promosOf(g, key);
    if (key === 'tile') unhideAll(g);
    for (var i = 0; i < promos.length; i++) promos[i].remove();
  }

  /* Srovná bannery jednoho typu na požadované pozice.
     ⚠️ Musí to být SROVNÁNÍ, ne jen „dolož chybějící": Globo při donačítání
     přepisuje kus mřížky a banner se posune o řadu jinam (typicky pruh z 2. na
     3. řadu). Když se pozice jen porovnají a případně opraví, je operace
     idempotentní → observer se po jednom průchodu uklidní a nezacyklí se. */
  function reconcile(g, t, items, want) {
    var promos = promosOf(g, t.key);
    var tpl = template(t.tpl);
    if (!tpl) return;

    for (var r = want.length; r < promos.length; r++) promos[r].remove();

    for (var k = 0; k < want.length; k++) {
      var node = promos[k];
      if (!node) node = tpl.content.firstElementChild.cloneNode(true);
      var anchor = items[want[k]];
      if (!anchor) break;
      if (node.nextElementSibling !== anchor || node.parentNode !== g) {
        g.insertBefore(node, anchor);
        if (t.key === 'wide' && getComputedStyle(g).display.indexOf('grid') === -1) {
          // Flexový grid: `grid-column` je mrtvé a šířku drží flex-basis, ne width.
          node.style.flex = '0 0 100%';
          node.style.width = '100%';
        }
      }
      if (t.key === 'tile' && t.opt.replace && !anchor.hasAttribute('data-tk-promo-hidden')) {
        anchor.style.setProperty('display', 'none', 'important');
        anchor.setAttribute('data-tk-promo-hidden', '1');
      }
    }
  }

  function place() {
    var g = grid();
    if (!g) return;

    var items = cards(g);
    var min = cfg.minProducts || 8;

    // Mřížka se scvrkla (přísný filtr) → bannery pryč, ať nezůstanou samy mezi ničím.
    if (items.length < min) {
      for (var x = 0; x < TYPES.length; x++) {
        if (promosOf(g, TYPES[x].key).length) removeAll(g, TYPES[x].key);
        TYPES[x].startIdx = null;
      }
      return;
    }

    var cols = columnCount(g, items);
    var tile = TYPES[0];
    var wide = TYPES[1];

    var widePos = [];
    if (wide.opt.enabled) {
      widePos = wantedPositions(wide, items.length, cols);
    } else if (promosOf(g, 'wide').length) {
      removeAll(g, 'wide');
    }

    var tilePos = [];
    if (tile.opt.enabled) {
      // Globo mřížku po filtru přepíše celou → bannery zmizí. Ber to jako novou mřížku
      // a pozici přelosuj; při pouhém donačtení drž tu původní.
      if (!promosOf(g, 'tile').length) tile.startIdx = null;
      if (tile.startIdx === null) tile.startIdx = firstIndex(tile.opt, items.length);
      tilePos = keepApart(wantedPositions(tile, items.length, cols), widePos, cols, items.length);
    } else if (promosOf(g, 'tile').length) {
      removeAll(g, 'tile');
    }

    if (wide.opt.enabled) reconcile(g, wide, items, widePos);
    if (tile.opt.enabled) reconcile(g, tile, items, tilePos);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      place();
    });
  }

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(schedule, 200);
  }

  function start() {
    var scope = document.querySelector('results-list') || grid() || document.body;
    new MutationObserver(schedule).observe(scope, { childList: true, subtree: true });
    window.addEventListener('popstate', schedule);
    window.addEventListener('resize', onResize);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
